import { render } from "./zhenggaokouqiang-news.vue?vue&type=template&id=d71ebb48&scoped=true"
import script from "./zhenggaokouqiang-news.vue?vue&type=script&lang=js"
export * from "./zhenggaokouqiang-news.vue?vue&type=script&lang=js"

import "./zhenggaokouqiang-news.vue?vue&type=style&index=0&id=d71ebb48&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d71ebb48"]])

export default __exports__